import { ImageType } from '../enums/image-type.enum';
import { Mimetypes } from './mime-types';

export const imageTypes = Object.values(ImageType).join(', ');
export const documentTypes = [...Object.values(ImageType), Mimetypes.Pdf, Mimetypes.Word].join(', ');
export const allTypes = '*/*';
